import { IS_PRIVATE } from '@/common/constant/platform';
import { getFileExt } from '@/renderer/scripts/utils/tools/index';
import store from '@/renderer/store';

// 公私环境：判断是否可预览图片
export function isAllowPreviewImage(name: string): boolean {
  return 'jpg|jpeg|png|webp|bmp|gif|heic|heif|svg'.split('|').includes(getFileExt(name).toLowerCase());
}

// 判断是否为万象支持的可预览图片
export function isAllowImageMogr(name: string): boolean {
  return 'jpg|jpeg|png|webp|bmp|gif|heic|heif'.split('|').includes(getFileExt(name).toLowerCase());
}

// 判断万象服务关闭（信创），浏览器媒体自带可预览图片
export function isAllowImageMedia(name: string): boolean {
  return 'jpg|jpeg|png|webp|bmp|gif'.split('|').includes(getFileExt(name).toLowerCase());
}

// 判断是否可预览视频
export function isAllowPreviewVideo(name: string): boolean {
  if (store.getters.isTclApp) {
    // 兼容TCL-Android电视平板支持的预览类型
    return 'mp4|webm|mkv|mov'.split('|').includes(getFileExt(name).toLowerCase());
  }
  return 'mp4|webm|ogv|ogg|mkv|avi|mov|wmv|flv|rmvb'.split('|').includes(getFileExt(name).toLowerCase());
}

// 判断是否可预览音频
export function isAllowPreviewAudio(name: string): boolean {
  return 'mp3|wav|aac|flac|ape'.split('|').includes(getFileExt(name).toLowerCase());
}

// 判断是否可预览音频
export function isAllowMobilePreviewAudio(name: string): boolean {
  return 'mp3|wav|aac|flac'.split('|').includes(getFileExt(name).toLowerCase());
}

// 判断是否可编辑文档
export function isAllowEditDoc(name: string): boolean {
  return store.getters.enableDocEditTypes.includes(getFileExt(name).toLowerCase());
}
export function isAllowEsign(name: string): boolean {
  return 'doc|docx|pdf'.split('|').includes(getFileExt(name).toLowerCase());
}

// 私有化下浏览器默认支持的可预览的文件格式
export function isAllowPrivate(name: string): boolean {
  return (
    'pdf|mp4|webm|flv'.split('|').includes(getFileExt(name).toLowerCase()) ||
    isAllowMobilePreviewAudio(name) ||
    (!store.getters.enableMediaProcessing ? isAllowImageMedia(name) : isAllowPreviewImage(name))
  );
}

// 不支持预览条件
export function noPreview(item: { name: string; previewByDoc?: boolean; previewByCI?: boolean }): boolean {
  if (IS_PRIVATE) {
    return (!item.previewByDoc || !item.previewByCI) && !isAllowPrivate(item.name as string);
  }
  return (
    (!item.previewByDoc || !item.previewByCI) &&
    !isAllowPreviewImage(item.name as string) &&
    !isAllowPreviewVideo(item.name as string) &&
    !isAllowPreviewAudio(item.name as string)
  );
}
